import { FetchPasswordResponseProps } from './types';

export const normalizePassword = (
  response: FetchPasswordResponseProps
): boolean => response.HasPassword;
